import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectIsLoading, selectSuppliers } from './supplier.selectors';

@Injectable({ providedIn: 'root' })
export class SupplierSelectorsFacade {
  private readonly _store = inject(Store);

  public readonly isLoading = this._store.selectSignal(selectIsLoading);

  public readonly suppliers = this._store.selectSignal(selectSuppliers);
}
